import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionInfoModalComponent } from './subscription-info-modal/subscription-info-modal.component';
import { SharedDialogsModule } from '@nx-fe/shared-dialogs';
import { EulaModalComponent } from './eula-modal/eula-modal.component';
import { ButtonModule } from '@nx-fe/button';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LicenseInfoComponent } from './subscription-info-modal/license-info/license-info.component';
import { LicenceInfoService, AccountService, AppSettingsService } from '@nx-fe/services';
import { ConfirmationDialogModalComponent } from './confirmation-dialog-modal/confirmation-dialog-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
export { SubscriptionInfoModalComponent, EulaModalComponent, WelcomeModalComponent, ConfirmationDialogModalComponent };
import { TooltipModule } from '@soti/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SharedDialogsModule,
    ButtonModule,
    ScrollingModule,
    FormsModule,
    PipesModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatCheckboxModule,
    TooltipModule
  ],
  declarations: [
    SubscriptionInfoModalComponent,
    EulaModalComponent,
    LicenseInfoComponent,
    WelcomeModalComponent,
    ConfirmationDialogModalComponent,
  ],
  exports: [
    SubscriptionInfoModalComponent,
    EulaModalComponent,
    WelcomeModalComponent,
    ConfirmationDialogModalComponent,
  ],
  providers: [LicenceInfoService, AccountService, AppSettingsService, XsI18nPipe],
})
export class CommonModalsModule {}
